import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class DataLayerService {
    public setWindiowDataLayer(event: string, pageType: string, pageTitle: string,
        element_id: string, product_code: string) {
        if (window.hasOwnProperty('dataLayer')) {
            window['dataLayer'].push({
                'event': event,
                'pageType': pageType,
                'pageTitle': pageTitle,
                'element_id': element_id,
                'product_code': product_code
            });
        }
        else {
            let errorMessgae = `window does not have dataLayer for...Event - ${event}, 
                Page Type - ${pageType}, Page Title - ${pageTitle}, CTA-id - ${element_id}, 
                Product Code - ${product_code}`;
            //throw new Error(errorMessgae);
            console.log("Data layer Error",errorMessgae)
        }
    }
}
